module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickAway),
      expression: "onClickAway"
    }],
    ref: "d_select",
    staticClass: "d-select text-dark",
    class: {
      'openFromBottom': _vm.openFromBottom
    }
  }, [_c('div', {
    staticClass: "width-100 no-print"
  }, [_c('div', {
    ref: "toggle",
    staticClass: "d-select__input-look",
    class: {
      'active': _vm.showDropdown
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._l((_vm.selectedItems), function(selectedItem) {
    return _c('div', {
      key: selectedItem.id,
      staticClass: "d-select__selected__item",
      class: [{
          'readyToDelete': _vm.isReadyToDelete(selectedItem)
        },
        {
          'd-select__selected__item--is-in-event': _vm.isInEvent
        },
        {
          'd-select__selected__item--cant-be-removed': _vm.isInItemsThatCantBeDeleted(selectedItem)
        }
      ]
    }, [(_vm.isInEvent) ? [(_vm.isLoadingAvailability) ? _c('div', {
      staticClass: "d-select__selected__item__spinner__container"
    }, [_c('div', {
      staticClass: "d-select__selected__item__spinner"
    })]) : [(_vm.isShowCollisions && selectedItem.v_occupation && selectedItem.v_occupation.length > 0) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'bottom',
          zIndex: 1231231231233,
          boundary: 'window'
        }),
        expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 1231231231233,\n                  boundary: 'window'\n                }"
      }],
      staticClass: "d-select__selected__item__warning icon__bg-circle icon__bg-circle--small",
      attrs: {
        "content": _vm.getCollisionText(selectedItem)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showCalendar(selectedItem)
        }
      }
    }, [_c('svg', {
      staticClass: "tw-icon tw-icon--warning",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
      }
    })])]) : _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'bottom',
          zIndex: 1231231231233,
          boundary: 'window'
        }),
        expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 1231231231233,\n                  boundary: 'window'\n                }"
      }],
      staticClass: "icon__bg-circle icon__bg-circle--small",
      attrs: {
        "content": _vm.i18n['see_calendar']
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showCalendar(selectedItem)
        }
      }
    }, [_c('svg', {
      staticClass: "tw-icon tw-icon--calendar",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
      }
    })])])]] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "d-select__selected__item__name",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showCalendar(selectedItem)
        }
      }
    }, [_vm._v("\n          " + _vm._s(selectedItem.name) + "\n        ")]), _vm._v(" "), (!_vm.isInItemsThatCantBeDeleted(selectedItem)) ? _c('div', {
      staticClass: "d-select__selected__item__remove icon__bg-circle icon__bg-circle--small icon__bg-circle--danger",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeUser(selectedItem)
        }
      }
    }, [_c('svg', {
      staticClass: "tw-icon--close",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      staticClass: "secondary",
      attrs: {
        "fill-rule": "evenodd",
        "d": "M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"
      }
    })])]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.selectedItems.length > 0 && _vm.isDeleteAllAnOption) ? _c('div', {
    staticClass: "d-select__delete-all",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeAllUsers.apply(null, arguments)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'top',
        zIndex: 1231231231233,
        animation: 'hift-away'
      }),
      expression: "{\n               arrow: true,\n                  placement : 'top',\n                  zIndex: 1231231231233,\n                  animation: 'hift-away'\n                }"
    }],
    staticClass: "icon__bg-circle",
    attrs: {
      "content": _vm.i18n['delete_all']
    }
  }, [_vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.isLoadingAvailability) ? _c('Loader', {
    staticClass: "input__spinner",
    staticStyle: {
      "margin": "6px 5px 0 5px"
    },
    attrs: {
      "isExtraSmall": true,
      "bg-color": "#fff",
      "color": "blue",
      "size": "small"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    staticClass: "input__spinner",
    staticStyle: {
      "margin": "6px 5px 0 5px"
    },
    attrs: {
      "isExtraSmall": true,
      "bg-color": "#fff",
      "color": "blue",
      "size": "small"
    }
  }) : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "inputfield",
    staticClass: "d-select__header__search",
    class: [{
      'show': _vm.showDropdown
    }, {
      'input-active': _vm.searchText.length > 0 || _vm.selectedItems.length < 1
    }],
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholderText
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "focus": _vm.open,
      "keypress": [function($event) {
        return _vm.selectWithKeyboard('', $event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.selectWithKeyboard('enter')
      }],
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.selectWithKeyboard('down')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.selectWithKeyboard('up')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.selectWithKeyboard('tab')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        return _vm.deleteUserWithKeyboard.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]], 2), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    directives: [{
      name: "append-to-body",
      rawName: "v-append-to-body"
    }],
    ref: "d_select__items",
    staticClass: "d-select__items"
  }, [_c('ul', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'left-start',
        zIndex: 12312312312312
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'left-start',\n                  zIndex: 12312312312312\n                }"
    }],
    ref: "dropdown",
    staticClass: "d-select__items__container text-dark",
    attrs: {
      "content": _vm.metaKeyTooltip
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._l((_vm.searchedUsers), function(item, index) {
    return [(index < _vm.maxLimit) ? _c('li', {
      key: item.id,
      class: [{
          'isReadyForSelection': _vm.isSelectedWithKeyboard(item)
        },
        {
          'item_is_selected': _vm.isSelected(item)
        }
      ],
      on: {
        "mouseenter": function($event) {
          return _vm.setIsReadyForSelection(item, index)
        },
        "mousemove": function($event) {
          _vm.isMouseMoved = true
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleUser(item)
        }
      }
    }, [_c('div', {
      staticClass: "item-template",
      class: [{
          'item-template--occupied': _vm.isShowCollisions && item.v_occupation && item.v_occupation.length > 0
        },
        {
          'item-template--presence': _vm.isShowCollisions && item.v_presence && item.v_presence.length > 0 && item.v_occupation && item.v_occupation.length < 1
        }
      ]
    }, [_c('div', {
      staticClass: "item-template__left"
    }, [(item.icon) ? _c('span', {
      staticClass: "marg-10-right",
      class: item.icon
    }) : _vm._e(), _vm._v(" "), (item.default_thumb_url) ? _c('img', {
      attrs: {
        "src": item.default_thumb_url
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (_vm.showCalendarYear) ? _c('div', {
      staticClass: "item-template__calendar-year"
    }, [_vm._v(_vm._s(item.year))]) : _vm._e(), _vm._v(" "), (_vm.isShowCollisions && item.v_occupation && item.v_occupation.length > 0) ? _c('ul', {
      staticClass: "item-template__occupations"
    }, [_c('span', {
      staticClass: "icon-warning"
    }), _vm._v(" "), _vm._l((item.v_occupation), function(event) {
      return _c('li', {
        key: event.event_id
      }, [_vm._v(_vm._s(event.title))])
    })], 2) : _vm._e()])]) : _vm._e()]
  }), _vm._v(" "), (_vm.searchedUsers.length > _vm.maxLimit) ? _c('li', {
    ref: "infinite_scroll",
    staticClass: "infinite-scroll__bottom"
  }, [_c('Loader', {
    staticStyle: {
      "margin": "12px"
    },
    attrs: {
      "is-extra-small": true,
      "bg-color": "#fff"
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), (_vm.showCreateButton && _vm.searchedUsers.length < 1) ? [(_vm.searchedUsers.length < 1 || (_vm.searchText.length > 0 && _vm.searchedUsers.length < 1)) ? _c('div', {
    staticClass: "no-match"
  }, [(_vm.searchText.length < 1) ? _c('h4', {
    staticClass: "create-new-item create-new-item--explained"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.dselect.type_to_create')) + "\n          ")]) : _c('h4', {
    staticClass: "create-new-item",
    on: {
      "click": _vm.createNew
    }
  }, [_vm._v("\n            + " + _vm._s(_vm.$t('vue2.common.create')) + " " + _vm._s(_vm.searchText) + "\n          ")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.showCreateButton && _vm.searchedUsers.length < 1) ? _c('div', {
    staticClass: "no-match",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("noMatch", function() {
    return [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')))])]
  })], 2) : _vm._e()], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-select__delete-all__inner"
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8029cc62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DSelect/DSelectCals.vue
// module id = 1755
// module chunks = 1